var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _vm.lang === "zh"
      ? _c("p", { staticClass: "icp" }, [
          _vm._v(
            " ©2015-" +
              _vm._s(new Date().getFullYear()) +
              " checkout.pingpongx.com. 杭州乒乓智能技术有限公司 All Rights Reserved. "
          ),
          _c("br"),
          _vm._v(
            "浙ICP备15025700号-1. 经营许可证:合字B2-20200174 浙公网安备 33010802003226号 "
          ),
        ])
      : _c("p", { staticClass: "icp" }, [
          _vm._v(
            " 2015-" +
              _vm._s(new Date().getFullYear()) +
              " © PingPong All rights reserved. "
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }